/* TEC Location → Checkout Address Prefill v2
 * Replaces v1. Single script, no dependency on guard's __tecCheckoutVerified flag.
 * When customer selects a location and clicks checkout, redirects to /checkout
 * with shipping address URL params so the Delivery section is pre-filled.
 */
(function(){
  if(window.__tecAddressPrefillV2)return;
  window.__tecAddressPrefillV2=true;

  var ADDRESS_MAP={
    "Alsip, IL":{a1:"4600 W. 120th St",city:"Alsip",province:"Illinois",zip:"60803"},
    "Blaine, MN":{a1:"10201 Xylite Street NE Ste 130",city:"Blaine",province:"Minnesota",zip:"55449"},
    "Crystal Lake, IL":{a1:"810 E Terra Cotta Ave",city:"Crystal Lake",province:"Illinois",zip:"60014"},
    "Elgin, IL":{a1:"1313 Timber Drive",city:"Elgin",province:"Illinois",zip:"60123"},
    "Elk Grove, IL":{a1:"475 Crossen Ave",city:"Elk Grove Village",province:"Illinois",zip:"60007"},
    "Hudson, WI":{a1:"1400 Heggen St",city:"Hudson",province:"Wisconsin",zip:"54016"},
    "Lansing, IL":{a1:"17725 Volbrecht Rd",city:"Lansing",province:"Illinois",zip:"60438"},
    "Lee's Summit, MO":{a1:"2600 NE Independence Ave",city:"Lee's Summit",province:"Missouri",zip:"64064"},
    "Libertyville, IL":{a1:"912A E Park Ave",city:"Libertyville",province:"Illinois",zip:"60048"},
    "Loves Park, IL":{a1:"4606 Interstate Blvd",city:"Loves Park",province:"Illinois",zip:"61111"},
    "Hobart/Merrillville, IN":{a1:"3240 E. 84th Place",city:"Merrillville",province:"Indiana",zip:"46342"},
    "Melrose Park, IL":{a1:"2055 N. Ruby St",city:"Melrose Park",province:"Illinois",zip:"60160"},
    "Merriam, KS":{a1:"5338 Merriam Dr",city:"Merriam",province:"Kansas",zip:"66203"},
    "New Berlin, WI":{a1:"16675 W Glendale Dr",city:"New Berlin",province:"Wisconsin",zip:"53151"},
    "Northfield, IL":{a1:"162 Northfield Rd",city:"Northfield",province:"Illinois",zip:"60093"},
    "North Aurora, IL":{a1:"100 Overland Dr",city:"North Aurora",province:"Illinois",zip:"60542"},
    "North Kansas City, MO":{a1:"1420 Gentry Street",city:"North Kansas City",province:"Missouri",zip:"64116"},
    "Plymouth, MN":{a1:"800 Berkshire Lane N",city:"Plymouth",province:"Minnesota",zip:"55441"},
    "South Bend, IN":{a1:"2603 Foundation Drive",city:"South Bend",province:"Indiana",zip:"46628"},
    "Stevensville, MI":{a1:"4340 N Roosevelt Rd",city:"Stevensville",province:"Michigan",zip:"49127"},
    "Summit, IL":{a1:"5539 S Archer Rd",city:"Summit",province:"Illinois",zip:"60501"},
    "Tinley Park, IL":{a1:"18500 North Creek Dr",city:"Tinley Park",province:"Illinois",zip:"60477"},
    "Valparaiso, IN":{a1:"605 Silhavy Rd",city:"Valparaiso",province:"Indiana",zip:"46383"},
    "Wheeling, IL":{a1:"550 Northgate Pkwy",city:"Wheeling",province:"Illinois",zip:"60090"},
    "Woodstock, IL":{a1:"1000 Courtaulds Dr",city:"Woodstock",province:"Illinois",zip:"60098"}
  };

  var SELECT_SEL='select[name="attributes[Choose Your Location]"]';
  var CHECKOUT_SEL='[name="checkout"],button[name="checkout"],input[name="checkout"],a[href*="/checkout"],#CartDrawer-Checkout,button[type="submit"][form="CartDrawer-Form"]';

  function log(){
    try{console.log.apply(console,['[TEC-ADDR]'].concat([].slice.call(arguments)));}catch(e){}
  }

  function getSelectedAddress(){
    var sels=document.querySelectorAll(SELECT_SEL);
    for(var i=0;i<sels.length;i++){
      var v=sels[i].value;
      if(v&&ADDRESS_MAP[v]){
        log('found selected location:',v);
        return ADDRESS_MAP[v];
      }
    }
    log('no location selected or no match');
    return null;
  }

  function buildCheckoutUrl(addr){
    var base='/checkout';
    var p=[];
    p.push('checkout[shipping_address][address1]='+encodeURIComponent(addr.a1));
    p.push('checkout[shipping_address][city]='+encodeURIComponent(addr.city));
    p.push('checkout[shipping_address][province]='+encodeURIComponent(addr.province));
    p.push('checkout[shipping_address][zip]='+encodeURIComponent(addr.zip));
    p.push('checkout[shipping_address][country]=United States');
    return base+'?'+p.join('&');
  }

  // Single checkout interceptor — capture phase, fires before anything else
  document.addEventListener('click',function(e){
    // Skip if this is our own programmatic navigation
    if(window.__tecAddressRedirecting)return;

    var target=e.target.closest?e.target.closest(CHECKOUT_SEL):null;
    if(!target)return;

    var addr=getSelectedAddress();
    if(!addr){
      log('no address to prefill, letting checkout proceed normally');
      return;
    }

    // Stop the click from doing anything
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var url=buildCheckoutUrl(addr);
    log('redirecting to:',url);

    // Persist the cart attribute first, then redirect
    window.__tecAddressRedirecting=true;
    var body='attributes%5BChoose%20Your%20Location%5D='+encodeURIComponent(
      (function(){
        var sels=document.querySelectorAll(SELECT_SEL);
        for(var i=0;i<sels.length;i++){if(sels[i].value)return sels[i].value;}
        return '';
      })()
    );

    fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'},
      body:body,
      credentials:'same-origin'
    }).then(function(){
      log('cart attribute persisted, navigating to checkout');
      window.location.href=url;
    }).catch(function(){
      log('persist failed, navigating anyway');
      window.location.href=url;
    });

    // Safety timeout — if fetch hangs, redirect anyway after 3s
    setTimeout(function(){
      if(window.__tecAddressRedirecting){
        log('timeout — forcing redirect');
        window.location.href=url;
      }
    },3000);
  },true);

  // Also intercept form submissions as backup
  document.addEventListener('submit',function(e){
    if(window.__tecAddressRedirecting)return;
    var form=e.target;
    if(!form||!form.querySelector)return;
    var hasCheckout=form.querySelector('[name="checkout"]')||form.querySelector('button[name="checkout"]');
    if(!hasCheckout)return;

    var addr=getSelectedAddress();
    if(!addr)return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var url=buildCheckoutUrl(addr);
    log('form submit intercepted, redirecting to:',url);
    window.__tecAddressRedirecting=true;
    window.location.href=url;
  },true);

  log('v2 ready');
})();
